import Cookies from 'js-cookie';
import type { SupportedStorage } from '@supabase/supabase-js';

/**
 * Determine if we're running on a bluelux.com domain
 */
const isBlueluxDomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.endsWith('.bluelux.com') || 
         window.location.hostname === 'bluelux.com';
};

/**
 * Get cookie options based on environment
 */
const getCookieOptions = () => {
  const baseOptions = {
    path: '/',
    sameSite: 'lax' as const,
    secure: window.location.protocol === 'https:',
    expires: 365,
  };

  // Only set domain restriction on bluelux.com domains
  if (isBlueluxDomain()) {
    return {
      ...baseOptions,
      domain: '.bluelux.com',
    };
  }

  // For preview/development, don't set domain (use browser default)
  return baseOptions;
};

/**
 * Custom cookie storage adapter for Supabase authentication
 * - On *.bluelux.com: Shares cookies across all subdomains
 * - On other domains (preview): Uses default browser behavior
 */
export const cookieStorage: SupportedStorage = {
  getItem: (key: string) => {
    return Cookies.get(key) ?? null;
  },
  setItem: (key: string, value: string) => {
    Cookies.set(key, value, getCookieOptions());
  },
  removeItem: (key: string) => {
    const removeOptions: { path: string; domain?: string } = { path: '/' };
    if (isBlueluxDomain()) {
      removeOptions.domain = '.bluelux.com';
    }
    Cookies.remove(key, removeOptions);
  },
};
